import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default__default from 'react';
import PropTypes__default from 'prop-types';
import HoneyBem from '../../../packages/honey-bem/honey-bem.js';
import styles from '../phone-input.scss.js';
import { Injecss } from '../../../packages/injecss/injecss.js';

const _excluded = ["callingCodes", "aria-label", "onChange", "disabled", "value"];
const bem = HoneyBem.init('phone-input', styles);
const CountrySelectorOption = _ref => {
  let {
    value,
    country,
    countryCode
  } = _ref;
  return /*#__PURE__*/React__default__default.createElement("option", {
    key: countryCode,
    value: value
  }, country);
};
CountrySelectorOption.displayName = 'CountrySelectorOption';
CountrySelectorOption.propTypes = {
  value: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.number]).isRequired,
  country: PropTypes__default.string.isRequired,
  countryCode: PropTypes__default.string.isRequired
};
const CountrySelector = _ref2 => {
  let {
      callingCodes,
      'aria-label': ariaLabel,
      onChange,
      disabled,
      value
    } = _ref2,
    rest = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/React__default__default.createElement("select", _extends({
    className: bem.e('select'),
    "aria-label": ariaLabel,
    onChange: onChange,
    disabled: disabled,
    value: value
  }, rest), callingCodes && callingCodes.map(callingCode => /*#__PURE__*/React__default__default.createElement(CountrySelectorOption, {
    key: callingCode.countryCode,
    value: callingCode.value,
    country: callingCode.country,
    countryCode: callingCode.countryCode
  })));
};
CountrySelector.displayName = 'CountrySelector';
CountrySelector.defaultProps = {
  disabled: false
};
CountrySelector.propTypes = {
  callingCodes: PropTypes__default.arrayOf(CountrySelectorOption).isRequired,
  'aria-label': PropTypes__default.string.isRequired,
  onChange: PropTypes__default.func.isRequired,
  disabled: PropTypes__default.bool,
  value: PropTypes__default.string.isRequired
};
var CountrySelector$1 = Injecss(CountrySelector, styles);

export { CountrySelector$1 as default };
